import type { Order } from '@/types'

type PaymentLike = { approved_at?: string | null; paid_at?: string | null }
type OrderLike = Partial<Order> & { created_at?: string; payment?: PaymentLike }

// 주문 시각 기준: 결제 승인(approved_at) → 결제 완료(paid_at) → 생성 시각(created_at)
export function getEffectiveOrderTime(order: OrderLike): string | undefined {
  return order?.payment?.approved_at
    || order?.payment?.paid_at
    || order?.created_at;
}
